import React, { useEffect, useState } from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditStudentLayer from "../components/EditStudentPage";


const EditStudent = () => {
  const [roleName, setRoleName] = useState("");
  useEffect(() => {

    const user = localStorage?.getItem("user");
    const parsedUser = JSON.parse(user);
    const role = parsedUser?.rolename;
    setRoleName(role);

  }, []);
  return (
    <>

        {/* Breadcrumb */}
        {roleName === "Admin" ? (
          <div className="d-flex justify-content-between"><h5>Edit Student  </h5><Breadcrumb title="Edit Student" /></div>
        ) : (
          <div className="d-flex justify-content-between"><h5>View Student  </h5><Breadcrumb title="Edit Student" /></div>
        )}
        {/* <div className="d-flex justify-content-between"><h5>Edit Student  </h5><Breadcrumb title="Edit Student" /></div> */}

        {/* UsersListLayer */}
        <EditStudentLayer />


    </>
  );
};

export default EditStudent; 